import { http } from './config'
import authHeader from './auth-header';

function consultaMassaQueryParams(filtros) {
    const c = (valor) => {
        if (valor === null || valor === undefined || valor === '') {
            return 'NULL';
        }
        return valor;
    };
    return {
        'idade-min': c(filtros.idadeMin),
        'idade-max': c(filtros.idadeMax),
        'data-inicial-utilizacao-servico': c(filtros.dataUtilizacaoServicoInicial),
        'data-final-utilizacao-servico': c(filtros.dataUtilizacaoServicoFinal),
        'data-inicial-falecimento': c(filtros.dataFalecimentoInicial),
        'data-final-falecimento': c(filtros.dataFalecimentoFinal),
        'data-inicial-nascimento-titular': c(filtros.dataNascimentoTitularInicial),
        'data-final-nascimento-titular': c(filtros.dataNascimentoTitularFinal),
        'data-inicial-cancelamento-contrato': c(filtros.dataCancelamentoContratoInicial),
        'data-final-cancelamento-contrato': c(filtros.dataCancelamentoContratoFinal),
        'data-inicial-adesao-contrato': c(filtros.dataAdesaoContratoInicial),
        'data-final-adesao-contrato': c(filtros.dataAdesaoContratoFinal),
        'data-inicial-vencimento-parcela': c(filtros.dataVencimentoParcelaInicial),
        'data-final-vencimento-parcela': c(filtros.dataVencimentoParcelaFinal),
        'data-inicial-pagamento-parcela': c(filtros.dataPagamentoParcelaInicial),
        'data-final-pagamento-parcela': c(filtros.dataPagamentoParcelaFinal),
        'data-inicial-emissao-documento': c(filtros.dataEmissaoDocumentoInicial),
        'data-final-emissao-documento': c(filtros.dataEmissaoDocumentoFinal),
        'status-utilizacao-servico': c(filtros.statusUtilizacaoServico),
        'situacao-contrato': c(filtros.situacaoContrato),
        'agrupamento': c(filtros.agrupamento),
        'empresa': c(filtros.selectedCompany),
        'tipo': c(filtros.selectedType),
        'produto': c(filtros.produto),
    };
}

export default {


    

    lista_cancelados_xls: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'filtro': filtro,
            'opcao': opcao,
            'produto': produto,

          };

       
          return http.get('/planilha-dash/lista-contrato-cancelados-xls', {
            params: params,
            responseType: 'blob', // Configurar responseType como 'blob' para baixar um arquivo binário
            headers: authHeader() // Certifique-se de incluir os cabeçalhos de autenticação aqui
          });

          
    },

    lista_inadimplencia_xls: (dataI, dataF, dataIR, dataFR, dataIE, dataFE,  nomeEmpresa, tipo, filtro, opcao, produto) => {

        const converteParaNull = (valor) => {
            return valor === null ? 'NULL' : valor;
        };

        const params = {
            'data-inicial': converteParaNull(dataI),
            'data-final': converteParaNull(dataF),
            'data-inicial-r': converteParaNull(dataIR),
            'data-final-r': converteParaNull(dataFR),
            'data-inicial-e': converteParaNull(dataIE),
            'data-final-e': converteParaNull(dataFE),
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'filtro': filtro,
            'opcao': opcao,
            'produto': produto

          };

       
          return http.get('/planilha-dash/lista-inadimplencia-xls', {
            params: params,
            responseType: 'blob', // Configurar responseType como 'blob' para baixar um arquivo binário
            headers: authHeader() // Certifique-se de incluir os cabeçalhos de autenticação aqui

          });

          
    },

    lista_contrato_vendas_empresa_xls: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'filtro': filtro,
            'opcao': opcao,
            'produto': produto
          };

       
          return http.get('/planilha-dash/lista-contrato-vendas-empresa-xls', {
            params: params,
            responseType: 'blob', // Configurar responseType como 'blob' para baixar um arquivo binário
            headers: authHeader() // Certifique-se de incluir os cabeçalhos de autenticação aqui

          });

          
    },

    lista_vendas_xls: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'filtro': filtro,
            'opcao': opcao,
            'produto': produto
          };

       
          return http.get('/planilha-dash/lista-contrato-vendas-xls', {
            params: params,
            responseType: 'blob', // Configurar responseType como 'blob' para baixar um arquivo binário
            headers: authHeader() // Certifique-se de incluir os cabeçalhos de autenticação aqui

          });

          
    },

    lista_receita_xls: (dataI, dataF, dataIR, dataFR, dataIE, dataFE, dataIC, dataFc, dataIA, dataFA, nomeEmpresa, tipo,  opcao, produto, origemDocumento, listDocBlack) => {

        const converteParaNull = (valor) => {
            return valor === null ? 'NULL' : valor;
        };

        // Converte array de origem para string separada por vírgula
        const origemStr = origemDocumento && Array.isArray(origemDocumento) 
            ? origemDocumento.join(',') 
            : origemDocumento || null;
        
        const params = {
            'data-inicial': converteParaNull(dataI),
            'data-final': converteParaNull(dataF),
            'data-inicial-r': converteParaNull(dataIR),
            'data-final-r': converteParaNull(dataFR),
            'data-inicial-e': converteParaNull(dataIE),
            'data-final-e': converteParaNull(dataFE),
            'data-inicial-c': converteParaNull(dataIC),
            'data-final-c': converteParaNull(dataFc),
            'data-inicial-a': converteParaNull(dataIA),
            'data-final-a': converteParaNull(dataFA),
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,
            'origem-documento': converteParaNull(origemStr)
          };

          if (listDocBlack === true) {
            params['list_doc_black'] = true;
          }

          return http.get('/planilha-dash/lista-contrato-receita-xls', {
            params: params,
            responseType: 'blob', // Configurar responseType como 'blob' para baixar um arquivo binário
            headers: authHeader() // Certifique-se de incluir os cabeçalhos de autenticação aqui

          });

          
    },


    lista_cancelados: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto, page, pageSize) => {
        const params = {
          'data-inicial': dataI,
          'data-final': dataF,
          'page': page,
          'size': pageSize,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'filtro': filtro,
          'opcao': opcao,
          'produto': produto,

        };
      
        return http.get('/contrato-dash/lista-contrato-cancelados', {
          params: params,
          headers: authHeader() // Certifique-se de incluir os cabeçalhos de autenticação aqui
        });
      },

      lista_vendas: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto, page, pageSize) => {

       const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'page': page,
            'size': pageSize,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'filtro': filtro,
            'opcao': opcao,
            'produto': produto
        }
        // Fazer a solicitação HTTP usando o Axios e passar os cabeçalhos configurados
        return http.get('/contrato-dash/lista-contrato-vendas', {
            params: params,
            headers: authHeader() 
      });
      },

      lista_vendas_entre_empresas: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto, page, pageSize) => {

        const params = {
             'data-inicial': dataI,
             'data-final': dataF,
             'page': page,
             'size': pageSize,
             'empresa': nomeEmpresa,
             'tipo': tipo,
             'filtro': filtro,
             'opcao': opcao,
             'produto': produto
         }
         // Fazer a solicitação HTTP usando o Axios e passar os cabeçalhos configurados
         return http.get('/contrato-dash/lista-contrato-vendas-empresas', {
             params: params,
             headers: authHeader() 
       });
       },



      
      lista_acordos: (dataI, dataF, dataIR, dataFR, dataIE, dataFE, nomeEmpresa, tipo, filtro, opcao, produto,  page, pageSize) => {
            
        const converteParaNull = (valor) => {
            return valor === null ? 'NULL' : valor;
        };
  
        const  params ={
            'data-inicial': converteParaNull(dataI),
            'data-final': converteParaNull(dataF),
            'data-inicial-r': converteParaNull(dataIR),
            'data-final-r': converteParaNull(dataFR),
            'data-inicial-e': converteParaNull(dataIE),
            'data-final-e': converteParaNull(dataFE),
            'page': page,
            'size': pageSize,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'filtro': filtro,
            'opcao': opcao,
            'produto': produto
        }

        // Fazer a solicitação HTTP usando o Axios e passar os cabeçalhos configurados
        return http.get('/contrato-dash/lista-contrato-acordos', {
            params: params,
            headers: authHeader() 
      });
    },

    lista_inadimplencia: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto, page, pageSize) => {
        // Fazer a solicitação HTTP usando o Axios e passar os cabeçalhos configurados
        const converteParaNull = (valor) => {
            return valor === null ? 'NULL' : valor;
        };

        const params = {
        'data-inicial': converteParaNull(dataI),
        'data-final': converteParaNull(dataF),
        'produto': produto,
        'empresa': nomeEmpresa,
        'tipo': tipo,
        'filtro': filtro,
        'opcao': opcao,
        'page': page,
        'size': pageSize,
    }
        return http.get('/contrato-dash/lista-inadimplencia', {
            params: params,
            headers: authHeader() 
          
    })
    },  

    lojas_cancelamento: (dataI, dataF, nomeEmpresa, tipo) => {
        // Fazer a solicitação HTTP usando o Axios e passar os cabeçalhos configurados
        const converteParaNull = (valor) => {
            return valor === null ? 'NULL' : valor;
        };

        const params = {
        'data-inicial': converteParaNull(dataI),
        'data-final': converteParaNull(dataF),
        'empresa': nomeEmpresa,
        'tipo': tipo
    }
        return http.get('/contrato-dash/total-contrato-cancelado-faixa-loja', {
            params: params,
            headers: authHeader() 
          
    })
    },  

    
        lista_receita: (dataI, dataF, dataIR, dataFR, dataIE, dataFE, dataIC, dataFC, dataIA, dataFA, nomeEmpresa, tipo, opcao, produto, origemDocumento, page, pageSize, listDocBlack) => {
            
            const converteParaNull = (valor) => {
                return valor === null ? 'NULL' : valor;
            };
      
            // Converte array de origem para string separada por vírgula
            const origemStr = origemDocumento && Array.isArray(origemDocumento) 
                ? origemDocumento.join(',') 
                : origemDocumento || null;

            const  params ={
                'data-inicial': converteParaNull(dataI),
                'data-final': converteParaNull(dataF),
                'data-inicial-r': converteParaNull(dataIR),
                'data-final-r': converteParaNull(dataFR),
                'data-inicial-e': converteParaNull(dataIE),
                'data-final-e': converteParaNull(dataFE),
                'data-inicial-c': converteParaNull(dataIC),
                'data-final-c': converteParaNull(dataFC),
                'data-inicial-a': converteParaNull(dataIA),
                'data-final-a': converteParaNull(dataFA),
                'page': page,
                'size': pageSize,
                'empresa': converteParaNull(nomeEmpresa),
                'tipo': converteParaNull(tipo),
                'opcao': converteParaNull(opcao),
                'produto': converteParaNull(produto),
                'origem-documento': converteParaNull(origemStr),

            }

            if (listDocBlack === true) {
                params['list_doc_black'] = true;
            }

            // Fazer a solicitação HTTP usando o Axios e passar os cabeçalhos configurados
            return http.get('/contrato-dash/lista-contrato-receita', {
                params: params,
                headers: authHeader() 

          });
        },

        lista_consulta_massa: (filtros) => {
            const params = {
                ...consultaMassaQueryParams(filtros),
                'page': filtros.page,
                'size': filtros.pageSize,
            };

            return http.get('/contrato-dash/lista-consulta-massa', {
                params: params,
                headers: authHeader(),
            });
        },

        lista_consulta_massa_xls: (filtros) => {
            const params = consultaMassaQueryParams(filtros);

            return http.get('/planilha-dash/lista-consulta-massa-xls', {
                params: params,
                responseType: 'blob',
                headers: authHeader(),
            });
        },

        
        lista_acordos_xls: (dataI, dataF, dataIR, dataFR, dataIE, dataFE, nomeEmpresa, tipo, filtro, opcao, produto) => {

            const converteParaNull = (valor) => {
                return valor === null ? 'NULL' : valor;
            };
    
            const params = {
                'data-inicial': converteParaNull(dataI),
                'data-final': converteParaNull(dataF),
                'data-inicial-r': converteParaNull(dataIR),
                'data-final-r': converteParaNull(dataFR),
                'data-inicial-e': converteParaNull(dataIE),
                'data-final-e': converteParaNull(dataFE),
                'produto': produto,
                'empresa': nomeEmpresa,
                'tipo': tipo,
                'filtro': filtro,
                'opcao': opcao,
              };

              return http.get('/planilha-dash/lista-contrato-acordos-xls', {
                params: params,
                responseType: 'blob', // Configurar responseType como 'blob' para baixar um arquivo binário
                headers: authHeader() // Certifique-se de incluir os cabeçalhos de autenticação aqui
    
              });
           
             
              
        },


         
   

    total_titular: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,        }

        return http.get('/contrato-dash/total-titular', {
              params: params,
            headers: authHeader() 
        })
    },

    total_dependente: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,        }
        return http.get('/contrato-dash/total-dependente', {
            params: params,
            headers: authHeader() 
        })
    },

    total_agregado: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,        }
        return http.get('/contrato-dash/total-agregado', {
            params: params,
            headers: authHeader() 
              
        })
    },

    total_agrupar_idade_titular: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,              }

        return http.get('/contrato-dash/total-agrupar-idade-titular', {
            params: params,
            headers: authHeader() 
              
        })
    },


    total_agrupar_idade_dep: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,            }
        return http.get('/contrato-dash/total-agrupar-idade-dep/',  {
            params: params,
            headers: authHeader() 
              
        })
    },

    total_dependente_falecido: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,
        }

        return http.get('/contrato-dash/total-dependente-falecido/',  {
             params: params,
            headers: authHeader()  
              
        })
    },

    total_agregado_falecido: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,        }

        return http.get('/contrato-dash/total-agregado-falecido', {
             params: params,
            headers: authHeader()  
              
        })
    },



    contrato_ativo: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,        }

        return http.get('/contrato-dash/total-contrato-ativo', {
             params: params,
            headers: authHeader()  
              
        })
    },


    total_vidas: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,


        }
        return http.get('/contrato-dash/total-vidas', {
            
            params: params,
            headers: authHeader()   
        })
    },

    total_cancelado: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
         const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,
        }

        return http.get('/contrato-dash/total-cancelado', {
            params: params,
            headers: authHeader()   
              
        })
    },

    
    
    media_falecimento: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,
        }

        return http.get('/contrato-dash/media-falecimento', {
            params: params,
            headers: authHeader()   
              
        })
    },

    media_titular: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,
        }

        return http.get('/contrato-dash/media-titular', {
            params: params,
            headers: authHeader()   
              
        })
    },

    media_dependente: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,
        }

        return http.get('/contrato-dash/media-dependente', {
            params: params,
            headers: authHeader()   
              
        })
    },

    media_agregado: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,
        }

        return http.get('/contrato-dash/media-agregado', {
            params: params,
            headers: authHeader()   
              
        })
    },


    
    

    tipo_contrato: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,         }

        return http.get('/contrato-dash/tipo-contrato', {
            params: params,
            headers: authHeader()   
              
        })
    },

    motivo_cancelamento: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
       
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,         }

        return http.get('/contrato-dash/motivo-cancelamento', {
             params: params,
            headers: authHeader()  
              
        })
    },

    contrato_sinistro: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,          }

        return http.get('/contrato-dash/contrato-sinistro', {
            params: params,
            headers: authHeader()  
              
        })
    },


    
    media_h_m: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto,
        }

        return http.get('/contrato-dash/media-h-m', {
            params: params,
            headers: authHeader()  
              
        })
    },

    contrato_total_faixa_at: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto
        }

        return http.get('/contrato-dash/total-contrato-ativo-faixa', {
            params: params,
            headers: authHeader()  
              
        })
    },


    contrato_total_faixa_ca: (dataI, dataF, nomeEmpresa, tipo, opcao, produto) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'opcao': opcao,
            'produto': produto
        }

        return http.get('/contrato-dash/total-contrato-cancelado-faixa', {
            params: params,
            headers: authHeader()  
              
        })
    },
    
    
    downloadFicha: (id) => {
        const params = new URLSearchParams([['id', id]])
        return http.get('download_ficha', { params }, { responseType: 'blob' },
        )
    },

    downloadZip: (id) => {
        const params = new URLSearchParams([['id', id]])
        return http.get('download_zip', { params }, { responseType: 'blob' },
        )
    },

}
